import * as urls from 'constans/urls'

export type SidebarMenuItem = {
  header?: string
  key?: string
  items?: Array<{
    name: string | React.ReactNode
    path: string
    key: string
    parent: string
  }>
}

const sidebarMenuItem: Array<SidebarMenuItem> = [
  {
    header: 'Khách hàng',
    key: 'Customer',
    items: [
      {
        name: 'Khách hàng',
        path: urls.CUSTOMER_URLS.List,
        key: 'CustomerInfo',
        parent: 'Customer',
      },
    ],
  },
  {
    header: 'Sản phẩm',
    key: 'Product',
    items: [
      {
        name: 'Danh sách sản phẩm',
        path: urls.PRODUCT_URLS.LIST,
        key: 'ProductList',
        parent: 'Product',
      },
    ],
  },
  {
    header: 'Quy tắc tem',
    key: 'RuleManagement',
    items: [
      {
        name: 'Danh sách quy tắc',
        path: urls.RULE_MANAGEMENT_URLS.LIST,
        key: 'RuleManagementList',
        parent: 'RuleManagement',
      },
      {
        name: 'Tạo quy tắc',
        path: urls.RULE_MANAGEMENT_URLS.CREATE,
        key: 'CreateRuleManagmenent',
        parent: 'RuleManagement',
      },
    ],
  },
  {
    header: 'Điều kiện quà tặng',
    key: 'GiftCondition',
    items: [
      {
        name: 'Danh sách điều kiện',
        path: urls.GIFT_CONDITION_URLS.LIST,
        key: 'GiftCondition',
        parent: 'GiftCondition',
      },
      {
        name: 'Tạo điều kiện',
        path: urls.GIFT_CONDITION_URLS.CREATE,
        key: 'CreateGiftCondition',
        parent: 'GiftCondition',
      },
    ],
  },
]
export default sidebarMenuItem
